import { Type, ComponentFactoryResolver } from '@angular/core';

export class ComponentItem {
  constructor(public component: Type<any>, public data: any, public resolver: ComponentFactoryResolver = null) {}
}
